<template>
    <rkm-row>
        <rkm-col cols="6">
            <rkm-form-radio-group
                label="Jornadas controladas por"
                v-model="data.model.controleJornada"
                :validations="validations.controleJornada"
            >
                <rkm-form-radio :value="enums.tipoControleJornada.ATENDIMENTO">Atendimentos</rkm-form-radio>
                <rkm-form-radio :value="enums.tipoControleJornada.EXAME">Exames</rkm-form-radio>
            </rkm-form-radio-group>
        </rkm-col>
    </rkm-row>
</template>

<script>

// Enuns.
import tipoControleJornada from '@/enums/exame-imagem/tipoControleJornada'

export default {
    computed: {
        validations() {

            return {
                controleJornada: { required: true},
            }
        },
    },
    data: () => ({
        enums: {
            tipoControleJornada
        },
    }),
    props: {
        data: { type: Object, required: true },
    },
}
</script>